export default "__VITE_ASSET__CZjfO$cV__"